import React from "react";
import { useTranslation } from "react-i18next";

import "../../i18next";

import AnimatedElement from "../AnimatedElement";
import solucionesAlamedida from "../../assets/images/home/solucionesAlamedida.jpg";

function SectionBgImage() {
  const { t } = useTranslation();

  const isMobile = window.innerWidth < 768;

  return (
    <section>
      <AnimatedElement
        fromDirection="left"
        className="relative pb-6"
      >
        {/* Imagen de fondo */}
        <img
          className="object-contain w-full h-[60vh] md:h-auto"
          src={solucionesAlamedida}
          alt="Soluciones a la medida"
        />

        {/* Título */}
        <div className="absolute bottom-8 md:bottom-[150px] left-0 w-full p-4 flex justify-start">
          <h2 className="text-3xl font-bold text-center md:text-right color-orange-atm md:text-[150px] leading-loose md:leading-relaxed mb-4 md:mb-0">
            {t("home_title_school")}
          </h2>
        </div>

        {/* Descripción */}
        <div className="absolute bottom-4 md:bottom-20 md:left-4 font-bold text-left w-[80%] md:w-[750px]">
          <p className="md:pl-4 rounded-xl text-white bg-[#FF5408] font-bold text-xs md:text-3xl p-2">
            {t("banner.atmDescription")}
          </p>
        </div>
      </AnimatedElement>
    </section>
  );
}

export default SectionBgImage;
